import { FC } from "react";
import { PAGINATION_DIRECTION } from "./types";
import { PaginationProps } from "./types";
import { usePagination, PaginationButton, PaginationItem } from ".";

const Pagination: FC<PaginationProps> = (props) => {
  const { currentPage, totalPages, variant, pageItemsToShow } = props;

  const {
    handlePageChange,
    isCurentPageInLastOrFirst,
    isCurrentPageInMiddle,
    firstNumbersGroup,
    lastNumbersGroup,
    middleNumbers,
  } = usePagination(props);

  return (
    <div className="flex items-center justify-center">
      <PaginationButton
        variant={variant}
        direction={PAGINATION_DIRECTION.RIGHT}
        text="قبلی"
        handleChangePage={() => handlePageChange(currentPage - 1)}
        disable={currentPage === 1}
        className="fds-l:ml-2.5 ml-1"
      />

      {isCurentPageInLastOrFirst &&
        firstNumbersGroup.map((page) => (
          <PaginationItem
            key={page}
            page={page}
            isCurrent={page === currentPage}
            onClick={() => handlePageChange(page)}
          />
        ))}

      {isCurentPageInLastOrFirst &&
        totalPages > pageItemsToShow &&
        lastNumbersGroup[0] - firstNumbersGroup[firstNumbersGroup.length - 1] >
          1 && <PaginationItem dots />}

      {isCurentPageInLastOrFirst &&
        totalPages > pageItemsToShow &&
        lastNumbersGroup.map((page) => (
          <PaginationItem
            key={page}
            page={page}
            isCurrent={page === currentPage}
            isLast={page === totalPages}
            onClick={() => handlePageChange(page)}
          />
        ))}

      {isCurrentPageInMiddle && (
        <PaginationItem page={1} onClick={() => handlePageChange(1)} />
      )}

      {isCurrentPageInMiddle && middleNumbers[0] - 1 > 1 && (
        <PaginationItem dots />
      )}

      {isCurrentPageInMiddle &&
        middleNumbers.map((page) => (
          <PaginationItem
            key={page}
            page={page}
            isCurrent={page === currentPage}
            onClick={() => handlePageChange(page)}
          />
        ))}

      {isCurrentPageInMiddle &&
        totalPages - middleNumbers[pageItemsToShow - 1] > 1 && (
          <PaginationItem dots />
        )}

      {isCurrentPageInMiddle && !middleNumbers.includes(totalPages) && (
        <PaginationItem
          page={totalPages}
          isLast
          onClick={() => handlePageChange(totalPages)}
        />
      )}

      <PaginationButton
        variant={variant}
        direction={PAGINATION_DIRECTION.LEFT}
        text="بعدی"
        handleChangePage={() => handlePageChange(currentPage + 1)}
        disable={currentPage === totalPages}
        className="fds-l:mr-2.5 mr-1"
      />
    </div>
  );
};

export default Pagination;
